export enum MenuDropdownItemId {
    SignOut = 'SIGN_OUT',
}
